import Vue from 'vue'

const ResourceDetailInstance = Vue.extend(require('./index.vue').default);
let instance = null
let resourceDetailPromise = null
let resourceDetailResolve = null

let getInstance = () => {
  return new ResourceDetailInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (resourceDetailResolve) {
    resourceDetailResolve(false)
    resourceDetailResolve = null
  }
  resourceDetailPromise = null
}

let ResourceDetail = (msg) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  resourceDetailPromise = new Promise((resolve, reject) => {
    resourceDetailResolve = resolve
  })
  instance.open(msg, resourceDetailResolve)

  return resourceDetailPromise
}

export default ResourceDetail
